import { Box, Image, Text } from "@chakra-ui/react";
import React from "react";

const Home = () => {
  const imgurl =
    "https://static.wixstatic.com/media/fdc839_256581ce11b541b39691e7981edb1f7b~mv2.jpg/v1/fill/w_640,h_400,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/fdc839_256581ce11b541b39691e7981edb1f7b~mv2.jpg";
  return (
    <Box w={"100%"} m="auto">
      <Text fontSize="40px" textAlign={"center"} mb={6}>
        Well Come To Masai Job Search App
      </Text>

      <Box  boxSize="xl" width={"80%"} m="auto">
        <Image boxSize="80%" objectFit={"contain"} margin="auto" src={imgurl} alt="Dan Abramov" />
      </Box>
    </Box>
  );
};

export default Home;
